import {
  IWalletCategory,
  IWalletType,
} from '~/@api/generated-api-types-user/Api'
import type { WalletSchema } from '../projects/_project_types/wallet.types'

function getWalletDisponibleFundsFixed(wallet: WalletSchema | null): number {
  if (!wallet) return 0

  return wallet.aggregates?.disponibleFunds ?? 0
}

function getMainInvestorWallet(
  wallets: Array<WalletSchema>
): WalletSchema | null {
  return (
    wallets.find(
      (wallet) =>
        wallet.category === IWalletCategory.Investor &&
        wallet.type === IWalletType.CSOB
    ) ?? null
  )
}

export { getWalletDisponibleFundsFixed, getMainInvestorWallet }
